'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareLinks = function ShareLinks(_ref) {
  var url = _ref.url;

  return _react2.default.createElement(
    'div',
    { className: 'ShareLinks' },
    _react2.default.createElement(
      'a',
      { href: 'https://twitter.com/home?status=' + encodeURIComponent(url), target: '_blank', rel: 'noopener noreferrer' },
      _react2.default.createElement(_.Icon, { name: 'twitter' })
    ),
    _react2.default.createElement(
      'a',
      { href: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), target: '_blank', rel: 'noopener noreferrer' },
      _react2.default.createElement(_.Icon, { name: 'facebook' })
    )
  );
};

ShareLinks.propTypes = {
  /**
   * The URL to share.
   */
  url: _propTypes2.default.string.isRequired
};

exports.default = ShareLinks;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/ShareLinks.js
// module id = 279
// module chunks = 0